module.exports = __webpack_public_path__ + "img/antes_despues_114.4d43eaee.png";